import { Component, EventEmitter, OnInit, Output, HostListener } from '@angular/core';
import { TemplateService } from '../../../../features/templates/services/template.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  @Output() selectedPromptId = new EventEmitter<any>();
  prompts: any[] = [];
  selectedPrompt: any = null;
  isDropdownOpen = false;
  isMobile = false;
  isSidebarVisible = true;

  constructor(private templateService: TemplateService) { }

  ngOnInit(): void {
    this.checkScreen();
    this.fetchPrompts();
  }

  @HostListener('window:resize')
  checkScreen() {
    this.isMobile = window.innerWidth <= 1080;
    this.isSidebarVisible = !this.isMobile; // visible on desktop, toggle on mobile
    if (!this.isMobile) this.isDropdownOpen = false;
  }

  toggleSidebarVisibility() {
    this.isSidebarVisible = !this.isSidebarVisible;
  }

  toggleDropdown() {
    if (this.isMobile) this.isDropdownOpen = !this.isDropdownOpen;
  }

  fetchPrompts(): void {
    this.templateService.getAllPrompts().subscribe({
      next: (data: any[]) => {
        this.prompts = data;
      },
      error: () => { }
    });
  }

  navigateToPrompt(promptId: any): void {
    this.selectedPrompt = this.prompts.find(p => p.id === promptId);
    this.selectedPromptId.emit(promptId);
    if (this.isMobile) this.isDropdownOpen = false; // close on select in mobile
  }
}
